import { temAcesso } from '@/shared/auth/temAcesso'

const Convenios = () => import('./Convenios.vue')
const ConvenioParecerFinaneiro = () => import('./parece_financeiro/ParecerFinanceiro.vue')
const ConvenioOficioEncerramento = () => import('./oficio_encerramento/OficioEncerramento.vue')
const ConvenioEmissaoDocumentos = () => import('./ConvenioEmissaoDocumentos.vue')
const ConvenioDetalhar = () => import('./detalhes/ConvenioDetalhar.vue')
const ConvenioNovo = () => import('./cadastro/CadConvenio')
const PrestacaoContasFinal = () => import('./cadastro/PrestacaoContasFinal')

// const ContratoAtualizarApostilar = () => import('./ContratoAtualizarApostilar.vue')
// const ContratoResponsavelForm = () => import('./responsaveis/ContratoResponsavelForm.vue')
// const PreContratoForm = () => import('./preContrato/PreContratoForm.vue')
// const DadosRmForm = () => import('./dadosRM/dadosRMForm.vue')
// const AditivarContrato = () => import('./aditivarContrato/AditivarContrato.vue')

export default {
    path: 'convenios',
    name: 'Convenios',
    component: Convenios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONV-00')) {
            next()
        }
    },
    children: [
        {
            path: ':convenioId/emissaodocumentos',
            name: 'Convenios_EmissaoDocumentos',
            component: ConvenioEmissaoDocumentos,
            beforeEnter: (to, from, next) => {
                if (temAcesso(['CONV-PAREC-FIN-00'])) {
                    next()
                }
            }
        },
        {
            path: ':convenioId/parecerfinanceiro',
            name: 'Convenios_ParecerFinanceiro',
            component: ConvenioParecerFinaneiro,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-PAREC-FIN-00')) {
                    next()
                }
            }
        },
        {
            path: ':convenioId/oficioencerramento',
            name: 'Convenios_OficioEncerramento',
            component: ConvenioOficioEncerramento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-OFIC-ENC-00')) {
                    next()
                }
            }
        },
        {
            path: ':convenioId/detalhar',
            name: 'Convenios_Detalhar',
            component: ConvenioDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-00')) {
                    next()
                }
            }
        },
        {
            path: 'NovoConvenio',
            name: 'Convenio_Novo',
            component: ConvenioNovo,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-00')) {
                    next()
                }
            }
        },

        {
            path: ':convenioId/EditarConvenio',
            name: 'Convenio_Editar',
            component: ConvenioNovo,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-00')) {
                    next()
                }
            }
        },

        {
            path: ':convenioId/:idPrestacaoContasMensal/PrestacaoContasFinal',
            name: 'PrestacaoContasFinal',
            component: PrestacaoContasFinal,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-00')) {
                    next()
                }
            }
        },

        // {
        //     path: ':contratoId/apostilar',
        //     name: 'Contratos_Apostilar',
        //     component: ContratoAtualizarApostilar,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-APOST-01')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/atualizar',
        //     name: 'Contratos_Atualizar',
        //     component: ContratoAtualizarApostilar,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-ELAB-00')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/atualizar',
        //     name: 'Contratos_Atualizar_Sem_Apostilar',
        //     component: ContratoAtualizarApostilar,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-ATUALIZAR-00')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/atualizardadosrm',
        //     name: 'Contratos_Atualizar_DadosRM',
        //     component: DadosRmForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-ELAB-00')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/responsavel/:responsavelId',
        //     name: 'Contratos_Responsavel_Atualizar',
        //     component: ContratoResponsavelForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso(['CONT-APOST-03'])) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/responsavel',
        //     name: 'Contratos_Responsavel_Inserir',
        //     component: ContratoResponsavelForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso(['CONT-APOST-03'])) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/aditivarcontrato',
        //     name: 'Contratos_Aditivar',
        //     component: AditivarContrato,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-ELAB-00')) {
        //             next()
        //         }
        //     }
        // },
    ]
}
